import { initializeApp } from "firebase/app";


const firebaseConfig = {
  apiKey: "AIzaSyAI0G59lL_XS1MAW60Me6MhvjK6p7Qt1us",
  authDomain: "maxshop-tahermamun10.firebaseapp.com",
  projectId: "maxshop-tahermamun10",
  storageBucket: "maxshop-tahermamun10.appspot.com",
  messagingSenderId: "411871930714",
  appId: "1:411871930714:web:99f3c653aae494702bab63",
  measurementId: "G-YKTQY00EEB"
};

const app = initializeApp(firebaseConfig)

export default app;
